import { FC } from "react";
import { Navigate } from "react-router-dom";
import { usePaths } from "routes";

export const ProfilePage: FC = () => {
  const paths = usePaths();

  return <Navigate to={paths.profileArtworks()} replace />;
};
